var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.11 7.434a4.752 4.752 0 0 1 8.78 0 .75.75 0 1 0 1.386-.574 6.252 6.252 0 0 0-11.553 0 .75.75 0 1 0 1.387.574z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.586 12.336C2 12.922 2 13.864 2 15.75c0 1.886 0 2.828.586 3.414.586.586 1.528.586 3.414.586h12c1.886 0 2.828 0 3.414-.586.586-.586.586-1.528.586-3.414 0-1.886 0-2.828-.586-3.414-.586-.586-1.528-.586-3.414-.586h-.75v-3a.75.75 0 1 0-1.5 0v3H6c-1.886 0-2.828 0-3.414.586zM6 16.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.34 8.62a2.25 2.25 0 0 1 4.32 0 .75.75 0 0 0 1.44-.42 3.75 3.75 0 0 0-7.2 0 .75.75 0 1 0 1.44.42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouter);
export default __webpack_public_path__ + "static/media/router.87750e02dc5df0cc3707139c0e5e43d1.svg";
export { ForwardRef as ReactComponent };